/* eslint-disable no-console */
import React, { useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import AddFunds from "./Add";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { addStripePayment } from "../../../redux/actions/stripePaymentAction";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLIC_KEY || process.env.STRIPE_PUBLIC_KEY || ""
);

function Payment({ updateBalance, type, selectedCurrency }) {
  const [clientSecret, setClientSecret] = useState("");
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.auth);

  // Determine currency based on user's active wallet instead of just country
  const userCurrency = selectedCurrency ? selectedCurrency.toLowerCase() : "usd";

  console.log("User country:", userData?.country, "Currency:", userCurrency);

  const [amountStripe, setamountStripe] = useState({
    user_id: null,
    amount: 0,
    currency: userCurrency,
    payment_method_types: ["card"],
  });
  const handleall = () => {
    console.log("go");
  };
  const handleTransferStripe = async (e) => {
    e.preventDefault();
    const payload = {
      user_id: Number(userData?.id),
      amount: Number(amountStripe.amount),
      currency: userCurrency,
      payment_method_types: ["card"],
    };

    console.log("Payment payload:", payload);

    try {
      const action = await addStripePayment(dispatch, payload);
      console.log("Client secret received:", action.payload);
      setClientSecret(action.payload);
    } catch (error) {
      console.error("Payment error:", error);
    }
  };
  // const options = {
  //   clientSecret:`${clientSecret}`
  // }
  const options = {
    mode: "payment",
    currency: userCurrency,
    amount: Number(amountStripe.amount) * 100 || 1000,
  };

  const handleChangeStripe = (e) => {
    const { name, value } = e.target;
    // Strip commas so "1,000" doesn't produce NaN when passed to Number()
    const sanitized = name === "amount" ? value.replace(/,/g, "") : value;
    setamountStripe((prev) => ({
      ...prev,
      [name]: sanitized,
    }));
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <AddFunds
        type={type}
        handleTransferStripe={handleTransferStripe}
        handleall={handleall}
        updateBalance={updateBalance}
        handleChangeStripe={handleChangeStripe}
        amountStripe={amountStripe.amount}
        clientSecret={clientSecret}
        selectedCurrency={selectedCurrency}
      />
    </Elements>
  );
}

export default Payment;
